export const useMobileDetect = () => {
  const userAgent = typeof navigator === 'undefined' ? /* istanbul ignore next */ 'SSR' : navigator.userAgent;

  const isIpad = Boolean(/ipad/i.test(userAgent)) || (/mac|mac os|macintel/gi.test(userAgent) && navigator.maxTouchPoints > 1);
  const isAndroid = Boolean(/android/i.test(userAgent));
  const isIos = Boolean(/iphone|ipod/i.test(userAgent)) || isIpad;

  return {
    isAndroid,
    isIos,
    isIpad
  };
};
